/**
 * Bestseller hover-swap for the "Catalog" mega menu.
 * Each sub-category link (Interieur, Exterieur, Lakverzorging, Velgen, Accessoires)
 * carries data-bestseller-* attributes for two products. On hover/focus, the
 * bestseller panel on the right updates both product cards (image, title, price, link).
 *
 * Uses event delegation on document so it keeps working even if the mega menu
 * markup is re-rendered by Shopify's Section Rendering API.
 */
(function () {
  function updatePanel(trigger) {
    var panel = trigger.closest('.mega-menu__grid');
    var target = panel
      ? panel.querySelector('[data-bestseller-panel]')
      : document.querySelector('[data-bestseller-panel]');

    if (!target) return;

    var image = trigger.getAttribute('data-bestseller-image');
    var url = trigger.getAttribute('data-bestseller-url');
    var title = trigger.getAttribute('data-bestseller-title');
    var price = trigger.getAttribute('data-bestseller-price');
    var image2 = trigger.getAttribute('data-bestseller-image2');
    var url2 = trigger.getAttribute('data-bestseller-url2');
    var title2 = trigger.getAttribute('data-bestseller-title2');
    var price2 = trigger.getAttribute('data-bestseller-price2');

    var imgEl = target.querySelector('[data-bestseller-img-el]');
    var linkEl = target.querySelector('[data-bestseller-link-el]');
    var titleEl = target.querySelector('[data-bestseller-title-el]');
    var priceEl = target.querySelector('[data-bestseller-price-el]');
    var imgEl2 = target.querySelector('[data-secondary-img-el]');
    var linkEl2 = target.querySelector('[data-secondary-link-el]');
    var titleEl2 = target.querySelector('[data-secondary-title-el]');
    var priceEl2 = target.querySelector('[data-secondary-price-el]');

    if (imgEl && image) imgEl.src = image;
    if (linkEl && url) linkEl.setAttribute('href', url);
    if (titleEl && title) titleEl.textContent = title;
    if (priceEl && price) priceEl.textContent = price;

    if (imgEl2 && image2) imgEl2.src = image2;
    if (linkEl2 && url2) linkEl2.setAttribute('href', url2);
    if (titleEl2 && title2) titleEl2.textContent = title2;
    if (priceEl2 && price2) priceEl2.textContent = price2;
  }

  function handleHoverEvent(event) {
    var trigger = event.target.closest && event.target.closest('[data-bestseller-image]');
    if (!trigger) return;
    updatePanel(trigger);
  }

  document.addEventListener('pointerover', handleHoverEvent);
  document.addEventListener('focusin', handleHoverEvent);
})();
